module.exports = __webpack_public_path__ + "img/庞红杰.4894bcbf.jpg";